module.exports = __webpack_public_path__ + "img/cloud2.a1cb4ab.png";